import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Circle } from "./styles";

const Ticker = ({ currStep }) => (
  <Wrapper>
    <Circle selected={currStep === 1} />
    <Circle selected={currStep === 2} />
    <Circle selected={currStep === 3} />
    <Circle selected={currStep === 4} />
    <Circle selected={currStep === 5} />
  </Wrapper>
);

Ticker.propTypes = {
  currStep: PropTypes.number
};

export default Ticker;
